var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simulator",style:(("top:" + _vm.top + "px"))},[_c('iframe',{attrs:{"src":(_vm.baseUrl + "mobile/index.html"),"frameborder":"0","id":"frame_full","scrolling":"auto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }